<template>
    <v-app>
        <v-main class="login">
            <v-container class="mx-auto my-auto" style="width: 100px">
                <v-progress-circular
                    :size="100"
                    :width="7"
                    color="blue"
                    indeterminate
                ></v-progress-circular>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
export default {
    props: {

    },

    data: () => ({

    }),

    methods: {

    },

    mounted() {
        this.$inertia.post(route('google.login'));
    },
};
</script>
